<script>
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  export let oldTaskData, form, errors, handleChange, handleSubmit, handleReasonSubmit;
  import FormTextarea from '../FormControls/FormTextarea.svelte';
  import { onMount } from 'svelte';
  import { Modal } from 'bootstrap';
  import { configItem, openStatusId } from '../../components/Helper';
  let updateReasonModal;
  onMount(() => {
    updateReasonModal = new Modal(document.getElementById('updateReasonTask'), {
      backdrop: false,
      keyboard: false,
    });
  });
  export const hide = () => {
    if (updateReasonModal != undefined) {
      updateReasonModal.hide();
    }
  };
  let popupOpened = false;
  const checkUpdateReason = () => {
    if (
      (openStatusId.includes(oldTaskData.status) && $form.status == 2) ||
      oldTaskData.assigneeUserId != $form.assigneeUserId ||
      oldTaskData.openDate != $form.openDate ||
      oldTaskData.dueDate != $form.dueDate ||
      oldTaskData.complianceStatus != $form.complianceStatus ||
      oldTaskData.riskRank != $form.riskRank ||
      oldTaskData.initialBoardDate != $form.initialBoardDate
    ) {
      if (
        popupOpened == false &&
        updateReasonModal != undefined &&
        oldTaskData.id != undefined &&
        $form.updateReason == ''
      ) {
        popupOpened = true;
        updateReasonModal.show();
      }
    }
  };
  $: $form && checkUpdateReason();
  export let cancelChanges = () => {};
</script>

<div
  class="modal fade"
  id="updateReasonTask"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header bg-transparent">
        <h5
          class="modal-title"
          id="staticBackdropLabel"
        >
          Reason for this update
        </h5>
      </div>
      <div class="modal-body modal-body-height p-3">
        <div class="form-group mb-3 position-relative">
          {#if openStatusId.includes(oldTaskData.status) && $form.status == 2}
            <div class="pt-0 pb-0 bg-white rounded box-shadow form-group mb-3 complete-date">
              <label
                for=""
                class="form-label"
                >Completion Date
                {#if $form.completeDate != ''}
                  <button
                    type="button"
                    color="primary"
                    class="btn btn-link mr-0 p-0 shadow-none border-0 shadow-none bg-transparent close-button"
                    style="width:12px;"
                    on:click={() => {
                      $form.completeDate = '';
                    }}
                  >
                    <img
                      class="btn-cancel"
                      alt=""
                      src="/images/close.svg"
                    />
                  </button>
                {/if}
              </label>
              <DatePicker
                Style=" update-calendar"
                placeholder="Complete Date"
                futureDates={false}
                on:change={(value) => {
                  $form.completeDate = value.detail[1];
                  // handleChange(customInputEvent('completeDate', value.detail[1]));
                }}
                value={$form.completeDate}
                error={$errors.completeDate}
                name="completeDate"
              />
            </div>
          {/if}
          {#if (openStatusId.includes(oldTaskData.status) && $form.status == 2) || oldTaskData.assigneeUserId != $form.assigneeUserId || oldTaskData.openDate != $form.openDate || oldTaskData.dueDate != $form.dueDate || oldTaskData.complianceStatus != $form.complianceStatus || oldTaskData.riskRank != $form.riskRank || oldTaskData.initialBoardDate != $form.initialBoardDate}
            <div class="pt-0 pb-0 bg-white rounded box-shadow">
              <FormTextarea
                label={openStatusId.includes(oldTaskData.status) && $form.status == 2
                  ? 'Add Notes'
                  : 'Please tell us why you are making this change?'}
                placeholder="Enter Notes (Optional)"
                handleChange={handleChange}
                error={$errors.updateReason}
                name="updateReason"
                bind:value={$form.updateReason}
                maxLength={configItem.maxLength.description}
              />
            </div>
          {/if}
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          color="primary"
          class="btn trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          on:click={() => {
            cancelChanges();
          }}
        >
          <span class="color-white font-size-12 font-weight-400"> Cancel </span>
        </button>

        <button
          type="button"
          color="primary"
          class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
          on:click={() => {
            if ($form.updateReason.trim() != '') {
              hide();
            }
            handleReasonSubmit();
          }}
        >
          <span class="color-white font-size-12 font-weight-400"> Save </span>
        </button>
      </div>
    </div>
  </div>
</div>
